import { render, staticRenderFns } from "./ServicesContainer.vue?vue&type=template&id=72ecfd81"
import script from "./ServicesContainer.vue?vue&type=script&lang=js"
export * from "./ServicesContainer.vue?vue&type=script&lang=js"
import style0 from "./ServicesContainer.vue?vue&type=style&index=0&id=72ecfd81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports